// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"7401defa755e9152","9651":"bccf8cac93884f0e"}[chunkId] + ".js";
};